<!--
描述：网站banner维护
日期：2022/04/25
created:lxd
-->
<template>
	<div class="bannerMaintain" style="min-width: 1400px">
		<el-row :gutter="40">
			<el-col :span="18">
				<div style="padding-left: 30px">
					<div style="height: 650px; border-right: 1px dashed #ddd">
						<div class="itemHeadName">项目应用：{{ parentObject.scopeName }}</div>
						<div class="itemHeadName flex-style">
							<div>缩略图 <span class="text">最多支持上传6张侧栏图片</span></div>
							<el-button type="primary" class="mr20" @click="handleAdd" v-if="parentObject.isUse == 0">新增</el-button>
						</div>
						<div class="miniimg clearfix">
							<div :span="4" v-for="(item, index) in miniImages" class="miniItem fl mb50 mr40" :key="'miniImages' + index">
								<div class="mb20 miniItemText">图 {{ index + 1 }}</div>
								<div class="mb20 miniItemImg cursor-pointer" @click="handleClickBanner(item)">
									<img :src="`${item.filePath}`" class="" width="100%" height="100%" alt="无图片" />
									<div class="mask" v-if="item.effective == 0">
										未到生效时间
									</div>
								</div>
								<div class="miniItemBtn" v-if="parentObject.isUse == 0">
									<span class="btnclorblue" @click="handleBannerBtn('up', item, index)"><i class="el-icon-top"></i>升序</span>
									<span class="btnclorblue" @click="handleBannerBtn('down', item, index)"><i class="el-icon-bottom"></i>降序</span>
								</div>
								<div class="miniItemBtn flex mt10" v-if="parentObject.isUse == 0">
									<span class="btnclorred" @click="handleBannerBtn('delete', item)"><i class="el-icon-close"></i>删除</span>
									<div class="switch-box">
										<el-switch
											class="switchStyle"
											v-model="item.status"
											active-text="启用"
											inactive-text="禁用"
											:active-value="1"
											:inactive-value="0"
											@change="handleBannerBtn('change', item)"
										>
										</el-switch>
									</div>
								</div>
							</div>
						</div>

						<div class="itemHeadName">
							<div class="itemHeadName fl">效果预览</div>
							<el-button type="primary" class="mr20 fr" @click="openUrl">预览</el-button>
						</div>
						<div class="miniimg clearfix">
							<div :span="4" v-for="(item, index) in miniImages" class="miniItem marginAuto" :key="'miniImages' + index">
								<div class="miniItemImg">
									<img :src="`${item.filePath}`" class="" width="100%" height="100%" alt="无图片" />
									<div class="mask" v-if="item.effective == 0">
										未到生效时间
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</el-col>
			<el-col :span="6">
				<div style="min-width: 200px" v-if="pictureDetail">
					<div class="itemHeadName"></div>

					<div class="title-style mb30">侧栏图片</div>
					<div class="upload-style">
						<upload
							ref="upload"
							:tableName="'web_banner'"
							listType="picture-card"
							:aid="formObj.id"
							:maxNum="maxNum"
							:isDisabled="parentObject.isUse == 1"
							:acceptType="acceptType"
							:width="400"
							:height="400"
							assortment="base_web_banner"
							:mode="parentObject.isUse == 1 ? 'view' : 'add'"
							@onUploadSuccess="onUploadSuccess"
						></upload>
					</div>

					<div class="url-box mb30">
						<div class="mb20 mt30 flex">
							<div class="title-style mr20">跳转URL</div>
							<div class="switch-box">
								<el-switch
									class="switchStyle"
									v-model="formObj.isSkip"
									active-text="启用"
									inactive-text="禁用"
									:active-value="1"
									:inactive-value="0"
									:disabled="parentObject.isUse != 0"
								>
								</el-switch>
							</div>
						</div>
						<el-input
							placeholder="请输入内容"
							v-model="formObj.skipUrl"
							v-show="formObj.isSkip == 1 || parentObject.isUse == 1"
							:disabled="parentObject.isUse != 0"
						>
							<template slot="prepend">Http://</template>
						</el-input>
					</div>

					<div class="date-box mt20 mb20">
						<div class="mb20 flex">
							<div class="title-style mr20">生效时间限制</div>
							<div class="switch-box">
								<el-switch
									class="switchStyle"
									v-model="formObj.isEffect"
									active-text="启用"
									inactive-text="禁用"
									:active-value="1"
									:inactive-value="0"
									:disabled="parentObject.isUse != 0"
								>
								</el-switch>
							</div>
						</div>
						<el-date-picker
							v-model="formObj.dateArr"
							type="daterange"
							value-format="yyyy-MM-dd"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							@change="timeChange"
							v-show="formObj.isEffect == 1 || parentObject.isUse == 1"
							:disabled="parentObject.isUse != 0"
						>
						</el-date-picker>
					</div>

					<div class="mt20 text-center" v-if="parentObject.isUse == 0">
						<el-button type="primary" @click="OpenPupo" size="medium" style="width: 240px" v-if="parentObject.isUse == 0">{{
							pictureMode == 'add' ? '添加' : '更新'
						}}</el-button>
					</div>
					<div class="mt20 text-center" v-if="parentObject.isUse == 0">
						<el-button type="info" size="medium" @click="handleCancel" style="width: 240px">取消</el-button>
					</div>
				</div>
			</el-col>
		</el-row>
		<el-dialog title="保存设置效果" :visible.sync="dialogVisible" width="40%" @closed="handleClose" center>
			<div class="delClass">
				确认后 “{{ webSystem.scopeName }}” 将<span class="red-color">应用相关更改</span> ，请<span class="red-color">谨慎</span> 操作！
			</div>
			<div>
				<span class="tishi"> 温馨提示：非网站管理人员，请勿进行本次操作 </span>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="handleClose">取消</el-button>
				<el-button type="primary" @click="handleSaveSettings(1)">确认</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
import { mapActions } from 'vuex'
import upload from 'components/upload/uploadPicture'
import { getWebBannerList, addWebBanner, updateBanner, insertOrUpdateBanner, changeState } from 'api/modules/website'
import { Snowflake } from 'node-snowflake'
export default {
	name: 'bannerMaintain',
	components: { upload },
	data() {
		return {
			maxNum: 1, //文件最大个数
			isNumber: 0, //banner的数量
			acceptType: ['jpg', 'jpeg', 'bmp', 'png'],
			miniImages: [], //轮播和缩略图的图片list
			formObj: {
				id: '',
				isSkip: 0, // 跳转是否启用 0：否；1：是
				skipUrl: '', // 跳转URL
				isEffect: 0, // 生效时间限制 0：否；1：是
				startTime: '', // 生效时间限制开始时间
				endTime: '', // 生效时间限制结束时间
				dateArr: [] // 生效时间限制
			},
			keepObj: {
				sysId: '', //必传 banner应用项目表主键id
				remark: '' // 备注
			},
			parentObject: {}, //父级数据
			dialogVisible: false,
			pictureDetail: false, // 默认不展示新增数据
			webSystem: {}, // 系统数据
			pictureMode: 'add' // 新增还是编辑
		}
	},

	created() {
		this.parentObject = this.$route.query
		this.keepObj.sysId = this.parentObject.id

		this.getWebBannerList()
	},
	methods: {
		...mapActions('app', ['setIsBack']),

		//获取网站banner列表
		getWebBannerList() {
			getWebBannerList({
				id: this.parentObject.id
			})
				.then((res) => {
					if (res.operationCode == 1) {
						this.miniImages = res.data.list
						this.isNumber = res.data.list.length
						this.webSystem = res.data.webSystem
						this.keepObj.remark = res.data.webSystem.remark
					}
				})
				.catch((err) => {})
		},

		// 对banner按钮操作
		handleBannerBtn(type, item, index) {
			let params = {}
			switch (type) {
				case 'up':
					if (index != 0) {
						params = {
							id: item.id,
							sortId: this.miniImages[index - 1].id,
							operateType: 1
						}

						this.updateBanner(params)
					} else {
						this.$message.warning('已经是第一张图片了！')
					}

					break
				case 'down':
					if (index != this.miniImages.length - 1) {
						params = {
							id: item.id,
							sortId: this.miniImages[index + 1].id,
							operateType: 1
						}

						this.updateBanner(params)
					} else {
						this.$message.warning('已经是最后一张图片了！')
					}
					break
				case 'delete':
					params = {
						id: item.id,
						operateType: 3
					}
					this.updateBanner(params)
					break
				case 'change':
					params = {
						id: item.id,
						status: item.status,
						operateType: 2
					}
					this.updateBanner(params)
					break
			}
		},

		// banner操作保存
		updateBanner(params) {
			updateBanner(params)
				.then((res) => {
					this.getWebBannerList()
				})
				.catch((err) => {})
		},

		//弹框
		OpenPupo() {
			if (this.$refs.upload.fileLength == 0) {
				return this.$message.warning('请先上传图片,再保存！')
			}
			if (this.isNumber > 5) {
				return this.$message.warning('最多支持6张侧栏广告图片,请先删除需要替换的图片，并保存设置效果后再上传！')
			}

			// 如果需要跳转且没有输入URL，则提示用户输入URL
			if (!this.formObj.skipUrl && this.formObj.isSkip == 1) {
				this.$message.warning('请输入跳转URL！')
				return
			}

			// 如果输入了URL，则验证URL格式
			if (this.formObj.skipUrl && this.formObj.isSkip == 1) {
				const urlPattern = /^((?:[\w-]+\.)+[a-z0-9]+)((?:\/[^/?#]*)+)?(\?[^#]+)?(#.+)?$/i
				let urlRight = urlPattern.test(this.formObj.skipUrl)
				if (!urlRight) {
					this.$message.warning('请输入正确的跳转URL！')
					return
				}
			}

			// 如果需要生效且有日期数组为空，则提示用户选择生效时间
			if (this.formObj.dateArr.length == 0 && this.formObj.isEffect == 1) {
				this.$message.warning('请选择生效时间！')
				return
			}
			// 如果所有验证都通过，则显示对话框
			this.dialogVisible = true
		},

		//保存设置效果

		handleSaveSettings() {
			// 手动上传图片
			if (this.$refs.upload.addList.length > 0) {
				this.$refs.upload.fileSend(this.formObj.id)
			} else {
				this.saveAll()
			}
		},

		// 上传成功
		onUploadSuccess({ res, dataParams }) {
			this.saveAll()
		},

		saveAll() {
			console.log(this.formObj)
			let params = JSON.parse(JSON.stringify(this.formObj))
			params.skipUrl = `https://${this.formObj.skipUrl}`
			params.sysId = this.keepObj.sysId
			if (params.isSkip == 0) {
				params.skipUrl = ''
			}
			if (params.isEffect == 0) {
				params.startTime = ''
				params.endTime = ''
			}

			delete params.dateArr
			insertOrUpdateBanner(params).then((res) => {
				this.$message.success('操作成功！')
				this.dialogVisible = false
				this.pictureDetail = false

				this.$refs.upload.addList = []

				// 获取最新数据
				this.getWebBannerList()
			})
		},
		// 上传成功
		// onUploadSuccess({ res, dataParams }) {
		//   console.log(this.formObj);
		//   let params = JSON.parse(JSON.stringify(this.formObj));
		//   params.skipUrl = `https://${this.formObj.skipUrl}`;
		//   params.sysId = this.keepObj.sysId;
		//   if (params.isSkip == 0) {
		//     params.skipUrl = "";
		//   }
		//   if (params.isEffect == 0) {
		//     params.startTime = "";
		//     params.endTime = "";
		//   }

		//   delete params.dateArr;
		//   insertOrUpdateBanner(params).then((res) => {
		//     this.$message.success("操作成功！");
		//     this.dialogVisible = false;
		//     this.pictureDetail = false;

		//     // 获取最新数据
		//     this.getWebBannerList();
		//   });
		// },

		// 新增banner图
		handleAdd() {
			if (this.isNumber > 5) {
				return this.$message.warning('最多支持6张侧栏广告图片,请先删除需要替换的图片，并保存设置效果后再上传！')
			}

			this.pictureDetail = true

			// 图片模式为新增
			this.pictureMode = 'add'
			setTimeout(() => {
				// 清空图片列表
				this.$refs.upload.addList = []
				this.formObj = {
					id: Snowflake.nextId(),
					isSkip: 0, // 跳转是否启用 0：否；1：是
					skipUrl: '', // 跳转URL
					isEffect: 0, // 生效时间限制 0：否；1：是
					startTime: '', // 生效时间限制开始时间
					endTime: '', // 生效时间限制结束时间
					dateArr: [] // 生效时间限制
				}
			}, 100)
		},

		// 新增取消
		handleCancel() {
			// 关闭
			this.pictureDetail = false
			this.$refs.upload.addList = []
		},

		// 时间change事件
		timeChange(data) {
			this.formObj.startTime = data ? data[0] : ''
			this.formObj.endTime = data ? data[1] : ''
		},

		// banner图点击
		handleClickBanner(data) {
			this.pictureDetail = true
			Object.keys(this.formObj).forEach((item) => {
				switch (item) {
					case 'startTime':
						this.formObj.startTime = data[item] ? data[item].slice(0, 10) : ''
						break
					case 'endTime':
						this.formObj.endTime = data[item] ? data[item].slice(0, 10) : ''
						break
					case 'dateArr':
						this.formObj.dateArr = []
						if (this.formObj.startTime) {
							this.formObj.dateArr.push(this.formObj.startTime)
						}
						if (this.formObj.endTime) {
							this.formObj.dateArr.push(this.formObj.endTime)
						}

						break
					case 'skipUrl':
						let newUrl = data[item]
						this.formObj.skipUrl = newUrl ? newUrl.slice(newUrl.indexOf('https://') + 'https://'.length) : ''
						break
					default:
						this.formObj[item] = data[item] ? data[item] : ''
						break
				}
			})
			this.pictureMode = 'edit'
		},

		// 关闭二次确认提示
		handleClose() {
			this.dialogVisible = false
		},
		//预览
		openUrl() {
			let url = ''
			// let codeArr=['content-1003','content-013','1008','013']
			console.log(this.parentObject.scope)
			switch (this.parentObject.scope) {
				case 'content-1003': //安招采内容页
					url = process.env.VUE_APP_PAGE_URL + 'NgsAzcWeb/#/portal'
					window.open(url)
					break
				case 'content-013': //专家通内容页
					url = process.env.VUE_APP_PAGE_URL + 'NgsAzcWeb/#/zjt/database-detail'
					window.open(url)
					break
				case '1008': //安招采首页
					url = process.env.VUE_APP_PAGE_URL + 'NgsAzcWeb/#/home'
					window.open(url)
					break
				case '013': //专家通首页
					url = process.env.VUE_APP_PAGE_URL + 'NgsAzcWeb/#/zjt/home'
					window.open(url)
					break
			}
		}
	},
	computed: {
		// 上传接口地址
		imgUrl() {
			return this.$uploadUrl
		}
	}
}
</script>
<style lang="less" scoped>
//提交审核弹窗宽度调整
.el-carousel__item {
	width: 1200px;
}

.bannerMaintain {
	// height: 100vh;
	height: 100%;

	.itemHeadName {
		height: 40px;
		line-height: 40px;
		font-size: 14px;
		font-weight: 600;

		.text {
			padding-left: 20px;
			color: #a10080;
			font-weight: normal;
			font-size: 12px;
		}
	}

	.image {
		img {
			max-width: 1200px;
			height: 200px;
		}
	}

	.tip {
		font-size: 14px;
		line-height: 25px;
	}

	.miniimg {
		padding: 20px 0;
		//width: 1240px;
		// border: 1px solid #000;
		font-size: 12px;

		.miniItem {
			width: 200px;

			.miniItemText {
				font-size: 14px;
				text-align: center;
			}

			.miniItemImg {
				position: relative;

				img {
					width: 200px;
					height: 100px;
				}

				.mask {
					width: 200px;
					height: 100px;
					text-align: center;
					line-height: 100px;
					color: #333;
					position: absolute;
					top: 0;
					left: 0;
					background: rgba(255, 255, 255, 0.7);
				}
			}

			.miniItemBtn {
				padding: 0 30px;
				display: flex;
				justify-content: space-between;
				max-width: 1000px;

				.btnclorblue {
					color: #0000ff;
					cursor: pointer;
				}

				.btnclorred {
					color: #ff0000;
					cursor: pointer;
				}
			}
		}
	}
}

.delClass {
	font-size: 16px;
	margin-bottom: 16px;
}

.tishi {
	font-size: 12px;
	color: #409eff;
}

.flex-style {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.title-style {
	font-size: 14px;
	font-weight: 600;
}

.upload-style {
	height: 140px;
}

/deep/.switch-box .switchStyle .el-switch__label {
	position: absolute;
	display: none;
	color: #fff;
}

/*打开时文字位置设置*/
/deep/.switch-box .switchStyle .el-switch__label--right {
	z-index: 1;
	right: 6px;
}

/*关闭时文字位置设置*/
/deep/.switch-box .switchStyle .el-switch__label--left {
	z-index: 1;
	left: 6px;
}

/*显示文字*/
/deep/.switch-box .switchStyle .el-switch__label.is-active {
	display: block;
	text-align: center;
}

/*开关按钮的宽度大小*/
/deep/.switch-box .switchStyle.el-switch .el-switch__core,
/deep/.switch-box .el-switch .el-switch__label {
	width: 60px !important;
}

/deep/ .el-range-separator {
	width: 20px !important;
}

.red-color {
	color: #ff0000;
}

.marginAuto {
	margin: 0 auto;
}
</style>
